/* eslint-disable no-nested-ternary */
import React from 'react';
import { Box, Card, styled, Tooltip, Typography } from '@mui/material';
import PaqueteriaAvatar from './PaqueteriaAvatar';
import { fCurrency } from '../../../../utils/formatNumber';
import { useLocation } from 'react-router';
import { Icon } from '@iconify/react';
import useAuthUsers from '../../../../hooks/useAuthUsers';
import useUserRole from '../../../../hooks/useUserRole';
import { getComission } from '../../../../utils/commision';

const CuztomCard = styled(Card)(({ pointer }) => ({
  padding: '10px',
  display: 'flex',
  justifyContent: 'space-evenly',
  gap: '15px',
  alignItems: 'center',
  cursor: pointer ? 'pointer' : '',
  height: '100%'
}));

function PaqueteriaCard({ item, pointer = 1, empaquetado = false, empaqTotal = null, origin }) {
  console.log(empaquetado, empaqTotal);
  const empaqPrice = empaqTotal ? Number(empaqTotal) : 0;
  const { search } = useLocation();
  const { currentUser } = useAuthUsers();
  const { admitByRoleName } = useUserRole();
  const queryParams = new URLSearchParams(search);
  const seguroVal = queryParams.get('seguro') === 'asegurado';
  // console.log('la carddddddddddddddddddd', item);

  console.log(getComission({ amount: item.amount }), item);

  return (
    <CuztomCard pointer={pointer}>
      <PaqueteriaAvatar rate_provider={item.rate_provider} />
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="subtitle2">{item.rate_provider}</Typography>
        {empaquetado && (
          <Typography component="span" fontSize="12px" color="primary">
            Incluye empaque
          </Typography>
        )}
        <Typography fontSize="20px" variant="subtitle2">
          {item.price
            ? origin === 'dagApp'
              ? fCurrency(item.price + empaqPrice)
              : fCurrency(getComission({ amount: item.price }).total + empaqPrice)
            : fCurrency(item.amount + empaqPrice)}

          {item.currency && (
            <Typography fontSize="10px" variant="subtitle2" component="span">
              {item.currency}
            </Typography>
          )}
          {'   '}
          {!!item.descuentoValue && (
            <Tooltip title="Descuento aplicado">
              <Typography color="secondary" fontSize="20px" variant="subtitle2" component="span">
                <Icon icon="fad:thunderbolt" />
              </Typography>
            </Tooltip>
          )}
        </Typography>

        {item?.volumetricWeight && (
          <Typography color="darkgreen" fontSize="12px" variant="subtitle2">
            Peso volumetrico: {item.volumetricWeight}
          </Typography>
        )}

        {seguroVal && (
          <Typography color="error" variant="subtitle2">
            Incluye seguro
          </Typography>
        )}

        <Typography variant="subtitle2">{item.service === 'Next day' ? '5 a 7 dias' : item.service}</Typography>
        {item.tiempo && (
          <Typography fontSize="13px" variant="subtitle2">
            {item.tiempo}
          </Typography>
        )}
        {item?.zonaExtendida && (
          <Typography fontSize="13px" variant="subtitle2">
            Zona extendida
          </Typography>
        )}
        {item.message && (
          <Typography color="primary" fontSize="13px" variant="subtitle2">
            {item.message}
          </Typography>
        )}

        {item?.dagpacketCode && (
          <Typography fontSize="13px" variant="subtitle2">
            Dagpacket Code: {item.dagpacketCode}
          </Typography>
        )}
        {item?.trackingNumber && (
          <Typography fontSize="13px" variant="subtitle2">
            Tracking N°: {item.trackingNumber}
          </Typography>
        )}
        {item?.licenUtility && admitByRoleName(['almighty', 'plus', 'basic', 'administrativo', 'lite'], ['cajero']) && (
          <Typography color="error" fontSize="13px" variant="subtitle2">
            SKU. {Math.ceil(item.costo + item.dagUtility)}.00000
          </Typography>
        )}
        {/* {item?.purchase_id && (
          <Typography fontSize="13px" variant="subtitle2">
            Compra ID: {item.purchase_id}
          </Typography>
        )} */}
      </Box>
    </CuztomCard>
  );
}

export default PaqueteriaCard;
